import '@angular/compiler';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/browser';
import { AuthService } from './app/core/services/auth.service';
import { AppComponent } from './app/app.component';
import { APP_CONFIG } from './app/app.config';
import { LandingComponent } from './app/landing/landing.component';
import { LANDING_CONFIG } from './app/landing/landing.config';

if (window.CONFIG.serverType == 'prod') {
	Sentry.init({
		dsn: 'https://f05ee9554bf37b658cbfbfb8a1b095d3@o4510227737542656.ingest.de.sentry.io/4510232100405328',
		integrations: [
			Sentry.replayIntegration({
				blockAllMedia: true,
				maskAllText: true,
				maskAllInputs: true,
				stickySession: false,
				networkDetailAllowUrls: [],
				networkCaptureBodies: false
			}),
			/*Sentry.replayCanvasIntegration({
				captureCanvas: true,
				frameRate: 1,
				maxCanvasSize: [1024, 512],
				scrollTarget: 'body',
				capturePerformance: false
			})*/
		],
		attachStacktrace: true,
		ignoreErrors: ['object unsubscribed'],
		sendDefaultPii: true,
		tracesSampleRate: 1.0,
		tracePropagationTargets: ['localhost', '127\.0\.0\.1', /^https:\/\/planohero\.datawiz\.io/],
		replaysSessionSampleRate: 0.0,
		replaysOnErrorSampleRate: 1.0,
	});
}

enableProdMode();

if (!window.location.href.includes('landing')) {
	if (window.location.href.includes('/frame/')) {
		const params = new URLSearchParams(window.location.search);
		const token: string = params.get('token');
		const refreshToken: string = params.get('refreshToken');
		if (token) {
			localStorage.setItem('datawiz_auth_access_token', token);
			localStorage.setItem('datawiz_auth_refresh_token', refreshToken);
		}
	}

	AuthService.auth().then(() => {
		bootstrapApplication(AppComponent, APP_CONFIG)
			.catch((err) => console.error(err));
	});
} else {
	bootstrapApplication(LandingComponent, LANDING_CONFIG)
		.catch((err) => console.error(err));
}